import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {AppConfig} from '../../App-Config';
import { Platform } from '@ionic/angular';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    private config = AppConfig.app;
    private win: any = window;
    constructor(private router: Router, protected platform: Platform) {

    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let authToken;
        let copiedRequest: HttpRequest<any>;
        if (req.url.includes(environment.remoteDataService)) {
            if (localStorage.getItem('token')) {
                authToken = 'Bearer ' + localStorage.getItem('token');
                copiedRequest = req.clone({ headers: req.headers.set('Authorization', authToken) });
            } else {
                if (req.url.includes('/access') || req.url.includes('/factors') || req.url.includes('/sysuser')) {
                    authToken = 'Bearer ' + environment.tempToken;
                    copiedRequest = req.clone({ headers: req.headers.set('Authorization', authToken) })
                } else {
                    authToken = 'Bearer ' + environment.tempToken;
                    copiedRequest = req.clone({ headers: req.headers.set('Authorization', authToken) });
                    // copiedRequest = req.clone();

                }
            }
            

        } else {
            copiedRequest = req.clone();
        }
        // if (this.platform.is('cordova')) {
        //     console.log("INTERCEPT: inside cordova", req.url)
        //     console.log("converted link:",this.webView.convertFileSrc(req.url));
        //     copiedRequest = req.clone({ url: this.webView.convertFileSrc(req.url)})
        // } else {
        //     console.log("INTERCEPT: outside cordova", req.url)
            
        // }
        return next.handle(copiedRequest).pipe(tap((event) => {
            }, (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401 && (err.error.message === "INVALID_TOKEN" || err.error.message === "JWT_EXPIRED" || err.error.message === "NO_AUTH_TOKEN")) {
                        console.log('request.interceptor: Token Expired, Logging out ');
                        localStorage.clear();
                        this.router.navigate(['/' + this.config.app_pathname + '/register']);
                    } else if (err.status === 401) {
                      //  this.router.navigate(['/']);
                    }
                }
            },
        ));
    }

}
